import { render, staticRenderFns } from "./RightFixBox.vue?vue&type=template&id=365789ae&scoped=true&"
import script from "./RightFixBox.vue?vue&type=script&lang=js&"
export * from "./RightFixBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "365789ae",
  null
  
)

export default component.exports